
















import Vue from 'vue'
import InputTextBox from '@/components/atoms/InputTextBox.vue'
import FeedbackMessage from '@/components/atoms/FeedbackMessage.vue'

export default Vue.extend({
  name: 'InputRegisterCode',
  components: {
    InputTextBox,
    FeedbackMessage
  },
  props: {
    inputLabel: String,
    registerCode: String,
    errorMessage: String,
    placeholder: String
  },
  methods: {
    changeRegisterCode: function (registerCode: string) {
      this.$emit('change', registerCode)
    }
  }
})
